import { render } from "./HeaderMenuMobile.vue?vue&type=template&id=4bc31ef4&scoped=true"
import script from "./HeaderMenuMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMenuMobile.vue?vue&type=script&lang=js"

import "./HeaderMenuMobile.vue?vue&type=style&index=0&id=4bc31ef4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4bc31ef4"

export default script